export default [
    // currency routes starts
    // {
    //     name: 'overview',
    //     path: 'overview',
    //     component: () =>
    //         import ('@/pages/dashboard/stats/Stats')
    // },
    {
        name: 'currency',
        path: 'currency',
        meta:{
            activeTabKey:'currency'
        },
        component: () =>
            import ('@/pages/dashboard/currency/Currency.vue')
    },
    {
        name: 'currency-add',
        path: 'currency/add',
        meta:{
            activeTabKey:'currency'
        },
        component: () =>
            import ('@/pages/dashboard/currency/AddCurrency.vue')
    },
    {
        name: 'currency-update',
        path: 'currency/update',
        meta:{
            activeTabKey:'currency'
        },
        component: () =>
            import ('@/pages/dashboard/currency/UpdateCurrency.vue')
    },
    // currency route Ends

    // pos route starts
    {
        name: 'pos-devices',
        path: 'pos-devices',
        meta:{
            activeTabKey:'pos-devices'
        },
        component: () =>
            import ('@/pages/dashboard/pos/POS.vue')
    },
    {
        name: 'add-pos-devices',
        path: 'pos-devices/add',
        meta:{
            activeTabKey:'pos-devices'
        },
        component: () =>
            import ('@/pages/dashboard/pos/AddPOS.vue')
    },
    {
        name: 'update-pos-devices',
        path: 'pos-devices',
        meta:{
            activeTabKey:'pos-devices'
        },
        component: () =>
            import ('@/pages/dashboard/pos/UpdatePOS.vue')
    },
    // pos route Ends

    //Rolling reserve Route starts

    {
        name: 'rolling-reserve',
        path: 'rolling-reserve',
        meta:{
            activeTabKey:'rolling-reserve'
        },
        component: () =>
            import ('@/pages/dashboard/rolling-reserve/RollingReserve.vue')
    },
    {
        name: 'rolling-reserve-add',
        path: 'rolling-reserve/add',
        meta:{
            activeTabKey:'rolling-reserve'
        },
        component: () =>
            import ('@/pages/dashboard/rolling-reserve/AddReserve.vue')
    },

    // Rolling reserve Route Ends

    /*slider route starts*/
    {
        name: 'slider',
        path: 'slider',
        meta:{
            activeTabKey:'slider'
        },
        component: () =>
            import ('@/pages/dashboard/slider/Slider.vue')
    },
    {
        name: 'slider-add',
        path: 'slider/add',
        meta:{
            activeTabKey:'slider'
        },
        component: () =>
            import ('@/pages/dashboard/slider/AddSlider.vue')
    },
    {
        name: 'slider-update',
        path: 'slider/update',
        meta:{
            activeTabKey:'slider'
        },
        component: () =>
            import ('@/pages/dashboard/slider/UpdateSlider.vue')
    },
    /*slider route ends*/

    // payment method route starts
    {
        name: 'payment-method',
        path: 'payment',
        meta:{
            activeTabKey:'payment-method'
        },
        component: () =>
            import ('@/pages/dashboard/payment-method/PaymentMethod')
    },
    {
        name: 'payment-update',
        path: 'payment/update',
        meta:{
            activeTabKey:'payment-method'
        },
        component: () =>
            import ('@/pages/dashboard/payment-method/UpdatePayment')
    },
    {
        name: 'payment-add',
        path: 'payment/add',
        meta:{
            activeTabKey:'payment-method'
        },
        component: () =>
            import ('@/pages/dashboard/payment-method/AddPayment')
    },
    // payment method route Ends

    // currency payment method route starts
    {
        name: 'currency-payment-method',
        path: 'currencyPayment',
        meta:{
            activeTabKey:'currency-payment-method'
        },
        component: () =>
            import ('@/pages/dashboard/currency-payments/CurrencyPayment.vue')
    },
    {
        name: 'currency-payment-method-add',
        path: 'currencyPayment/add',
        meta:{
            activeTabKey:'currency-payment-method'
        },
        component: () =>
            import ('@/pages/dashboard/currency-payments/AddCurrencyPayment.vue')
    },
    {
        name: 'currency-payment-method-update',
        path: 'currencyPayment/update',
        meta:{
            activeTabKey:'currency-payment-method'
        },
        component: () =>
            import ('@/pages/dashboard/currency-payments/UpdateCurrencyPayment.vue')
    },
    // currency payment method route starts

    // Feature route starts
    {
        name: 'features',
        path: 'features',
        meta:{
            activeTabKey:'features'
        },
        component: () =>
            import ('@/pages/dashboard/features/features.vue')
    },
    {
        name: 'features-add',
        path: 'features/add',
        meta:{
            activeTabKey:'features'
        },
        component: () =>
            import ('@/pages/dashboard/features/AddFeatures.vue')
    },
    {
        name: 'features-update',
        path: 'features/update',
        meta:{
            activeTabKey:'features'
        },
        component: () =>
            import ('@/pages/dashboard/features/UpdateFeatures.vue')
    },
    // Feature route Ends

    // Group route Starts
    {
        name: 'role',
        path: 'role',
        meta:{
            activeTabKey:'role'
        },
        component: () =>
            import ('@/pages/dashboard/group/Group.vue')
    },
    {
        name: 'group-add',
        path: 'group/add',
        meta:{
            activeTabKey:'role'
        },
        component: () =>
            import ('@/pages/dashboard/group/AddGroup.vue')
    },
    {
        name: 'group-update',
        path: 'group/update',
        meta:{
            activeTabKey:'role'
        },
        component: () =>
            import ('@/pages/dashboard/group/UpdateGroup.vue')
    },
    {
        name: 'group-default-update',
        path: 'group/default-update',
        meta:{
            activeTabKey:'role'
        },
        component: () =>
            import ('@/pages/dashboard/group/UpdateDefaultStatus.vue')
    },
    {
        name: 'manage-group-channel',
        path: 'manage-group-channel',
        meta:{
            activeTabKey:'role'
        },
        component: () =>
            import ('@/pages/dashboard/group/GroupChannel')
    },
    {
        name: 'manage-group-store',
        path: 'manage-group-store',
        meta:{
            activeTabKey:'role'
        },
        component: () =>
            import ('@/pages/dashboard/group/GroupStore')
    },
    // Group route Ends

    // Privilege route starts
    {
        name: 'privilege',
        path: 'privilege',
        meta:{
            activeTabKey:'privilege'
        },
        component: () =>
            import ('@/pages/dashboard/privilege/Privilege.vue')
    },
    {
        name: 'privilege-add',
        path: 'privilege/add',
        meta:{
            activeTabKey:'privilege'
        },
        component: () =>
            import ('@/pages/dashboard/privilege/AddPrivilege.vue')
    },
    {
        name: 'privilege-charges-add',
        path: 'privilege-charges-add',
        meta:{
            activeTabKey:'privilege'
        },
        component: () =>
            import ('@/pages/dashboard/privilege/privilege-role/AddCharges.vue')
    },
    {
        name: 'privilege-update',
        path: 'privilege/update',
        meta:{
            activeTabKey:'privilege'
        },
        component: () =>
            import ('@/pages/dashboard/privilege/UpdatePrivilege.vue')
    },
    {
        name: 'privilege-role-add',
        path: 'privilege-role-add',
        meta:{
            activeTabKey:'privilege'
        },
        component: () =>
            import ('@/pages/dashboard/privilege/privilege-role/PrivilegeRole.vue')
    },
    {
        name: 'privilege-group-add',
        path: 'privilege-group-add',
        meta:{
            activeTabKey:'privilege'
        },
        component: () =>
            import ('@/pages/dashboard/privilege/privilege-role/AddGroups.vue')
    },
    // Privilege route Ends

    // Role route Starts
    {
        name: 'roles',
        path: 'roles',
        meta:{
            activeTabKey:'roles'
        },
        component: () =>
            import ('@/pages/dashboard/roles/roles.vue')
    },
    {
        name: 'roles-add',
        path: 'roles-add',
        meta:{
            activeTabKey:'roles'
        },
        component: () =>
            import ('@/pages/dashboard/roles/addRoles.vue')
    },
    {
        name: 'roles-update',
        path: 'roles-update',
        meta:{
            activeTabKey:'roles'
        },
        component: () =>
            import ('@/pages/dashboard/roles/updateRoles.vue')
    },
    {
        name: 'roles-permissions',
        path: 'roles-permissions/:roleId',
        meta:{
            activeTabKey:'roles'
        },
        component: () =>
            import ('@/pages/dashboard/roles/rolesPermissions.vue')
    },
    // Role route Ends

    // Permission route Starts
    {
        name: 'permissions',
        path: 'permissions',
        meta:{
            activeTabKey:'permissions'
        },
        component: () =>
            import ('@/pages/dashboard/permissions/permissions.vue')
    },
    // {
    //     name: 'permissions-add',
    //     path: 'permissions-add',
    //     meta:{
    //         activeTabKey:'permissions'
    //     },
    //     component: () =>
    //         import ('@/pages/dashboard/permissions/addPermission.vue')
    // },
    {
        name: 'permissions-update',
        path: 'permissions-update',
        meta:{
            activeTabKey:'permissions'
        },
        component: () =>
            import ('@/pages/dashboard/permissions/updatePermission.vue')
    },
    // Role route Ends

    // Admin user starts
    {
        name: 'admin-users',
        path: 'admin-users',
        meta:{
            activeTabKey:'admin-users'
        },
        component: () =>
            import ('@/pages/dashboard/admin-user/Users.vue')
    },
    {
        name: 'admin-add',
        path: 'admin-add',
        meta:{
            activeTabKey:'admin-user'
        },
        component: () =>
            import ('@/pages/dashboard/admin-user/AddUser.vue')
    },
    {
        name: 'admin-update',
        path: 'admin-update',
        meta:{
            activeTabKey:'admin-user'
        },
        component: () =>
            import ('@/pages/dashboard/admin-user/updateUser.vue')
    },
    {
        name: 'user-roles',
        path: 'user-roles/:userId',
        meta:{
            activeTabKey:'admin-user'
        },
        component: () =>
            import ('@/pages/dashboard/admin-user/userRoles.vue')
    },
    // Admin user ends

    // Settings route starts
    {
        name: 'settings',
        path: 'settings',
        meta:{
            activeTabKey:'settings'
        },
        component: () =>
            import ('@/pages/dashboard/settings/settings.vue')
    },
    {
        name: 'settings-add',
        path: 'settings-add',
        meta:{
            activeTabKey:'settings'
        },
        component: () =>
            import ('@/pages/dashboard/settings/AddSettings.vue')
    },
    {
        name: 'settings-update',
        path: 'settings-update',
        meta:{
            activeTabKey:'settings'
        },
        component: () =>
            import ('@/pages/dashboard/settings/UpdateSettings.vue')
    },
    // Settings route ends

    // Users route Starts
    // {
    //     name: 'user',
    //     path: 'user',
    //     component: () =>
    //         import ('@/pages/dashboard/users/users.vue')
    // },
    // {
    //     name: 'user-update',
    //     path: 'user-update',
    //     component: () =>
    //         import ('@/pages/dashboard/users/updateStatus.vue')
    // },
    // {
    //     name: 'user-add',
    //     path: 'user-add',
    //     component: () =>
    //         import ('@/pages/dashboard/users/addUser.vue')
    // },
    // {
    //     name: 'user-wallet',
    //     path: 'user-wallet',
    //     component: () =>
    //         import ('@/pages/dashboard/users/user-wallet/UserWallet.vue')
    // },
    {
        name: 'app-users',
        props: true,
        path: 'app-users',
        meta:{
            activeTabKey:'app-users'
        },
        component: () =>
            import ('@/pages/dashboard/users/users.vue')
    },
    {
        name: 'user-detail',
        props: true,
        path: 'app-users/detail/:id',
        meta:{
            activeTabKey:'app-users'
        },
        component: () =>
            import ('@/pages/dashboard/users/UserDetails.vue')
    },
    {
        name: 'user-groups',
        path: 'app-users/group/:id',
        props: true,
        meta:{
            activeTabKey:'app-users'
        },
        component: () =>
            import ('@/pages/dashboard/users/UserGroup.vue')
    },
    {
        name: 'user-profile',
        path: 'user-profile',
        meta:{
            activeTabKey:'app-users'
        },
        props: true,
        component: () =>
            import ('@/pages/dashboard/users/UserProfile.vue')
    },
    // Users route ends

    // Partner route Starts
    {
        name: 'partners',
        path: 'partners',
        props: true,
        meta:{
            activeTabKey:'partners'
        },
        component: () =>
            import ('@/pages/dashboard/partners/partners.vue')
    },
    {
        name: 'partner-detail',
        path: 'partners/detail/:id',
        meta:{
            activeTabKey:'partners'
        },
        props: true,
        component: () =>
            import ('@/pages/dashboard/partners/PartnerDetails.vue')
    },
    {
        name: 'partner-settlement-configuration',
        path: 'partners/settlement-configuration/:partnerId',
        meta:{
            activeTabKey:'partners'
        },
        component: () =>
            import ('@/pages/dashboard/partners/partnerSettlementConfiguration')
    },
    // Partner route ends

    // Merchant route Starts
    {
        name: 'merchants',
        path: 'merchants',
        props: true,
        meta:{
            activeTabKey:'merchants'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/merchants.vue')
    },
    {
        name: 'merchant-profile',
        path: 'merchant-profile',
        props: true,
        meta:{
            activeTabKey:'merchants'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/MerchantProfile')
    },
    // pfac route starts
    {
        name: 'pfac',
        path: 'merchants/pfac',
        meta:{
            activeTabKey:'merchants'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/pfac/PFAC.vue')
    },
    {
        name: 'add-pfac',
        path: 'merchants/pfac/add',
        meta:{
            activeTabKey:'merchants'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/pfac/AddPFAC.vue')
    },
    {
        name: 'update-pfac',
        path: 'merchants/pfac/update',
        meta:{
            activeTabKey:'merchants'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/pfac/UpdatePFAC.vue')
    },
    // pfac route Ends

    // store switch route starts
    {
        name: 'switch',
        path: 'merchants/store/switch',
        meta:{
            activeTabKey:'merchants'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/stores/switch/Switch.vue')
    },
    // store switch route ends

    // channel switch route starts
    {
        name: 'channel-switch',
        path: 'merchants/channel/switch',
        meta:{
            activeTabKey:'merchants'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/channels/channel-switch/ChannelSwitch.vue')
    },
    // channel switch route ends

    // {
    //     name: 'merchant-tms',
    //     path: 'merchant-tms',
    //     props: true,
    //     meta:{
    //         activeTabKey:'merchants'
    //     },
    //     component: () =>
    //         import ('@/pages/dashboard/merchant/MerchantTMS')
    // },
    {
        name: 'merchant-detail',
        path: 'merchants/detail/:id',
        meta:{
            activeTabKey:'merchants'
        },
        props: true,
        component: () =>
            import ('@/pages/dashboard/merchant/MerchantDetails.vue')
    },
    {
        name: 'merchant-settings',
        path: 'merchants/setting/:id',
        meta:{
            activeTabKey:'merchants'
        },
        props: true,
        component: () =>
            import ('@/pages/dashboard/merchant/MerchantSettings.vue')
    },
    {
        name: 'merchant-groups',
        path: 'merchants/group/:id',
        meta:{
            activeTabKey:'merchants'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/MerchantGroup.vue')
    },
    {
        name: 'merchant-settlement-configuration',
        path: 'merchants/settlement-configuration/:merchantId',
        meta:{
            activeTabKey:'merchants'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/merchantSettlementConfiguration')
    },
    // Merchant route Ends

    /*Merchant logs routes start*/
    {
        name: 'get-logs',
        path: 'get-logs/:id',
        props: true,
        meta:{
            activeTabKey:'adapt'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/logs/MerchantLogs')
    },
    {
        name: 'general-logs',
        path: 'general-logs',
        props: true,
        meta:{
            activeTabKey:'Logs'
        },
        component: () =>
            import ('@/pages/dashboard/logs/GeneralLogs')
    },
    /*Merchant logs routes ends*/

    /*Revenue route starts*/
    {
        name: 'revenue',
        path: 'revenue',
        meta:{
            activeTabKey:'revenue'
        },
        component: () =>
            import ('@/pages/dashboard/revenue/Revenue')
    },
    {
        name: 'revenue-summary',
        path: 'revenue/summary/:currency/:id',
        meta:{
            activeTabKey:'revenue'
        },
        component: () =>
            import ('@/pages/dashboard/revenue/RevenueSummary')
    },
    /*Revenue route Ends*/

    {
        name: 'user-stat-info',
        path: 'user-stat-info/:currencyCode/:currencyId/:merchantStatus',
        meta:{
            activeTabKey:'overview'
        },
        component: () =>
            import ('@/pages/dashboard/stats/UserStatInfo')
    },
    {
        name: 'transaction-volume',
        path: 'transaction-volume',
        meta:{
            activeTabKey:'overview'
        },
        component: () =>
            import ('@/pages/dashboard/stats/TransactionVolume')
    },

    // Payment Link route Starts
    {
        name: 'payment-links',
        path: 'payment-links',
        meta:{
            activeTabKey:'payment-links'
        },
        component: () =>
            import ('@/pages/dashboard/payment-link/paymentLink.vue')
    },
    {
        name: 'payment-transaction',
        path: 'payment-transaction',
        meta:{
            activeTabKey:'payment-links'
        },
        component: () =>
            import ('@/pages/dashboard/payment-link/paymentTransaction.vue')
    },
    {
        name: 'payment-link-attempt',
        path: 'payment-link/attempt/:id',
        meta:{
            activeTabKey:'payment-links'
        },
        component: () =>
            import ('@/pages/dashboard/payment-link/PaymentLinkAttempListing.vue')
    },
    {
        name: 'payment-link-attempt-detail',
        path: 'payment-link/attempt/:id/detail',
        meta:{
            activeTabKey:'payment-links'
        },
        component: () =>
            import ('@/pages/dashboard/payment-link/PaymentLinkAttempLogs.vue')
    },
    // Payment Link route Ends

    // Customers route Starts
    {
        name: 'customers',
        path: 'customers',
        meta:{
            activeTabKey:'customers'
        },
        component: () =>
            import ('@/pages/dashboard/customer/customer.vue')
    },
    // Customers Link route Ends

    //withdrawal-requests route starts
    {
        name: 'withdrawal-requests',
        path: 'withdrawal-requests',
        props: true,
        meta:{
            activeTabKey:'withdrawal-requests'
        },
        component: () =>
            import ('@/pages/dashboard/withdrawal-requests/withdrawalRequests.vue')
    },
    {
        name: 'withdrawal-status',
        path: 'withdrawal-status',
        props: true,
        meta:{
            activeTabKey:'withdrawal-requests'
        },
        component: () =>
            import ('@/pages/dashboard/withdrawal-requests/changeWithdrawalStatus.vue')
    },
    // withdrawal-requests route Ends

    // Transaction route starts
    {
        name: 'transactions',
        path: 'transactions',
        props: true,
        meta:{
            activeTabKey:'transactions'
        },
        component: () =>
            import ('@/pages/dashboard/transactions/transactions.vue')
    },
    {
        name: 'transactions-detail',
        path: 'transactions/detail/:id',
        meta:{
            activeTabKey:'adapt'
        },
        props: true,
        component: () =>
            import ('@/pages/dashboard/transactions/TransactionDetailsFromExternal')
    },
    {
        name: 'transactions-card-detail',
        path: 'transactions/card/:transactionStatus/:id',
        meta:{
            activeTabKey:'transactions'
        },
        props: true,
        component: () =>
            import ('@/pages/dashboard/transactions/CardDetails')
    },
    // Transaction route Ends

    /*Ledger routes start*/
    {
        name: 'account-ledger',
        path: 'account-ledger/:id',
        meta:{
            activeTabKey:'adapt'
        },
        component: () =>
            import ('@/pages/dashboard/account-ledger/AccountLedger')
    },
    {
        name: 'account-ledger-vp',
        path: 'account-ledger-vp/:id',
        meta:{
            activeTabKey:'adapt'
        },
        component: () =>
            import ('@/pages/dashboard/account-ledger/VpAccountLedger')
    },
    {
        name: 'account-ledger-merchant',
        path: 'account-ledger-merchant/:id/:uuid',
        meta:{
            activeTabKey:'adapt'
        },
        component: () =>
            import ('@/pages/dashboard/account-ledger/AccountLedgerMerchant')
    },
    /*Ledger routes ends*/

    /*balance on hold routes start*/
    {
        name: 'balance-on-hold',
        path: 'balance-on-hold/:id/:uuid',
        meta:{
            activeTabKey:'adapt'
        },
        component: () =>
            import ('@/pages/dashboard/balanceOnHold/BalanceOnHold')
    },
    /*balance on hold routes ends*/

    //charges route starts
    {
        name: 'charges',
        path: 'charges',
        meta:{
            activeTabKey:'charges'
        },
        component: () =>
            import ('@/pages/dashboard/charges/charges.vue')
    },
    {
        name: 'add-charges',
        path: 'add-charges',
        meta:{
            activeTabKey:'charges'
        },
        component: () =>
            import ('@/pages/dashboard/charges/addCharges.vue')
    },
    {
        name: 'update-charges',
        path: 'update-charges',
        meta:{
            activeTabKey:'charges'
        },
        component: () =>
            import ('@/pages/dashboard/charges/updateCharges.vue')
    },
    // Charges route ends

    //kyc group route starts
    {
        name: 'kyc-group',
        path: 'kyc-group',
        meta:{
            activeTabKey:'kyc-group'
        },
        component: () =>
            import ('@/pages/dashboard/kyc-group/KycGroup.vue')
    },
    {
        name: 'add-kyc-group',
        path: 'add-kyc-group',
        meta:{
            activeTabKey:'kyc-group'
        },
        component: () =>
            import ('@/pages/dashboard/kyc-group/addKycGroup.vue')
    },
    {
        name: 'update-kyc-group',
        path: 'update-kyc-group',
        meta:{
            activeTabKey:'kyc-group'
        },
        component: () =>
            import ('@/pages/dashboard/kyc-group/updateKycGroup.vue')
    },
    // kyc group route ends


    //acquiring route starts
    {
        name: 'aquirings',
        path: 'aquirings',
        meta:{
            activeTabKey:'aquirings'
        },
        component: () =>
            import ('@/pages/dashboard/acquirings/acquiring')
    },
    {
        name: 'add-acquirings',
        path: 'add-acquirings',
        meta:{
            activeTabKey:'aquirings'
        },
        component: () =>
            import ('@/pages/dashboard/acquirings/addAcquiring')
    },
    {
        name: 'update-acquirings',
        path: 'update-acquirings',
        meta:{
            activeTabKey:'aquirings'
        },
        component: () =>
            import ('@/pages/dashboard/acquirings/updateAcquiring')
    },
    {
        name: 'acquirings-transction-type',
        path: 'acquirings-transction-type',
        meta:{
            activeTabKey:'aquirings'
        },
        component: () =>
            import ('@/pages/dashboard/acquirings/acquiringTransactionTypes')
    },

    {
        name: 'schema-groups',
        path: 'schema-groups/:schemaId',
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/acquirings/acquiringGroups')
    },




    //schema route starts
    {
        name: 'schema',
        path: 'schema',
        props: true,
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/schema')
    },
    {
        name: 'add-schemas',
        path: 'add-schemas',
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/addSchema')
    },
    {
        name: 'update-schemas',
        path: 'update-schemas',
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/updateSchema')
    },
    {
        name: 'acquiring-details',
        path: 'acquiring-details',
        props: true,
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/acquiringSchemaDetailsList')
    },
    {
        name: 'schema-acquirings-transction-type',
        path: 'schema-acquirings-transction-type',
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/schemaAcquiringTransactionTypes')
    },
    {
        name: 'add-schema-acquirings-settings',
        path: 'add-schema-acquirings-settings',
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/addSchemaAcquiringSettings')
    },
    {
        name: 'schema-aquiring-limits',
        path: 'schema-aquiring-limits/:acquiringId',
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/schemaAquiringLimit')
    },
    {
        name: 'manage-aquiring-limits',
        path: 'manage-aquiring-limits/:acquiringId',
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/manageSchemaAcquireLimit')
    },
    {
        name: 'schema-transction-type-charges',
        path: 'schema-transction-type-charges/:acquiringId',
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/transactionTypesCharges')
    },
    {
        name: 'add-schema-transction-type-charges',
        path: 'add-schema-transction-type-charges/:acquiringId',
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/addSchemaTransactionTypeCharges')
    },
    {
        name: 'update-schema-transction-type-charges',
        path: 'update-schema-transction-type-charges',
        meta:{
            activeTabKey:'schema'
        },
        component: () =>
            import ('@/pages/dashboard/schema/updateSchemaTransactionTypeCharges')
    },


    //store route starts
    {
        name: 'merchant-stores',
        path: 'merchant-stores',
        meta:{
            activeTabKey:'merchant-stores'
        },
        props: true,
        component: () =>
            import ('@/pages/dashboard/merchant-stores/merchantStore')
    },
    {
        name: 'merchant-add-store',
        path: 'merchant-add-store/:userId',
        meta:{
            activeTabKey:'merchant-stores'
        },
        component: () =>
            import ('@/pages/dashboard/merchant-stores/merchantAddStore')
    },
    {
        name: 'merchant-update-store',
        path: 'merchant-update-store/:userId',
        meta:{
            activeTabKey:'merchant-stores'
        },
        component: () =>
            import ('@/pages/dashboard/merchant-stores/merchantUpdateStore')
    },
    {
        name: 'merchant-account-activation',
        path: 'merchant-store/account-activation',
        meta:{
            activeTabKey:'merchant-stores'
        },
        component: () =>
            import ('@/pages/dashboard/merchant-stores/merchantStoreAccountActivation')
    },
    {
        name: 'merchant-store-settlement-configuration',
        path: 'merchant-store/settlement-configuration/:storeId',
        meta:{
            activeTabKey:'merchant-stores'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/stores/storeSettlementConfiguration')
    },
    {
        name: 'store',
        path: 'store',
        meta:{
            activeTabKey:'store'
        },
        props: true,
        component: () =>
            import ('@/pages/dashboard/merchant/stores/store')
    },
    {
        name: 'add-store',
        path: 'add-store/:userId',
        meta:{
            activeTabKey:'store'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/stores/addStore')
    },
    {
        name: 'update-store',
        path: 'update-store/:userId',
        meta:{
            activeTabKey:'store'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/stores/updateStore')
    },
    {
        name: 'account-activation',
        path: 'store/account-activation',
        meta:{
            activeTabKey:'store'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/stores/storeAccountActivation')
    },
    {
        name: 'store-settlement-configuration',
        path: 'store/settlement-configuration/:storeId',
        meta:{
            activeTabKey:'store'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/stores/storeSettlementConfiguration')
    },
    //store route ends

    //terminal route starts
    {
        name: 'terminal',
        path: 'terminal',
        meta:{
            activeTabKey:'terminal'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/terminals/terminal')
    },
    {
        name: 'add-terminal',
        path: 'add-terminal/:storeId',
        meta:{
            activeTabKey:'terminal'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/terminals/addTerminal')
    },
    {
        name: 'update-terminal',
        path: 'update-terminal/:storeId',
        meta:{
            activeTabKey:'terminal'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/terminals/updateTerminal')
    },
    //terminal route ends

    //dcc transactions details route starts
    {
        name: 'dcc-transactions-details',
        path: 'dcc-transactions-details',
        meta:{
            activeTabKey:'dcc-transactions-details'
        },
        component: () =>
            import ('@/pages/dashboard/dcc-transactions-details/DccTransactionsDetails')
    },
    //dcc transactions details route ends

    //channel route starts
    {
        name: 'channel',
        path: 'channel',
        meta:{
            activeTabKey:'channel'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/channels/channel')
    },
    {
        name: 'add-channel',
        path: 'add-channel/:terminalId',
        meta:{
            activeTabKey:'channel'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/channels/addChannel')
    },
    {
        name: 'update-channel',
        path: 'update-channel/:terminalId',
        meta:{
            activeTabKey:'channel'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/channels/updateChannel')
    },
    {
        name: 'configuration-settings',
        path: 'configuration-settings/:channelId',
        meta:{
            activeTabKey:'channel'
        },
        component: () =>
            import ('@/pages/dashboard/merchant/channels/configrationSettings')
    },
    //channel route ends





    // Refund-request routing starts
    {
        name: 'refund-requests',
        path: 'refund-requests',
        meta:{
            activeTabKey:'refund-requests'
        },
        component: () =>
            import ('@/pages/dashboard/refund-request/refundRequest.vue')
    },
    // Refund-request routing Ends

    //API Payment routing starts
    {
        name: 'api-payments',
        path: 'api-payments',
        meta:{
            activeTabKey:'api-payments'
        },
        component: () =>
            import ('@/pages/dashboard/api-payments/ApiPayments.vue')
    },
    //API payment routing Ends

    // Settlements API route starts
    {
        name: 'direct-settlements',
        props: true,
        path: 'settlements/direct-settlements',
        meta:{
            activeTabKey:'direct-settlements'
        },
        component: () =>
            import ('@/pages/dashboard/settlements/direct/DirectSettlement')
    },
    {
        name: 'create-direct-settlements',
        path: 'settlements/direct-settlements/create',
        meta:{
            activeTabKey:'direct-settlements'
        },
        component: () =>
            import ('@/pages/dashboard/settlements/direct/CreateDirectSettlement')
    },
    {
        name: 'direct-settlements-detail',
        props: true,
        path: 'settlements/direct-settlements/:settlementStatus/:id',
        meta:{
            activeTabKey:'direct-settlements'
        },
        component: () =>
            import ('@/pages/dashboard/settlements/direct/DirectSettlementDetail')
    },
    {
        name: 'direct-settlements-skipped-detail',
        props: true,
        path: 'settlements/direct-settlements/skipped/:settlementStatus/:id',
        meta:{
            activeTabKey:'direct-settlements'
        },
        component: () =>
            import ('@/pages/dashboard/settlements/direct/DirectSkippedSettlementDetail')
    },
    {
        name: 'aggregator-settlements',
        path: 'settlements/aggregator-settlements',
        meta:{
            activeTabKey:'aggregator-settlements'
        },
        props: true,
        component: () =>
            import ('@/pages/dashboard/settlements/aggregate/AggregateSettlement')
    },
    {
        name: 'create-aggregator-settlements',
        path: 'settlements/aggregator-settlements/create',
        meta:{
            activeTabKey:'aggregator-settlements'
        },
        component: () =>
            import ('@/pages/dashboard/settlements/aggregate/CreateAggregateSettlement')
    },
    {
        name: 'aggregator-settlements-detail',
        props: true,
        path: 'settlements/aggregator-settlements/:settlementStatus/:id',
        meta:{
            activeTabKey:'aggregator-settlements'
        },
        component: () =>
            import ('@/pages/dashboard/settlements/aggregate/AggregateSettlementDetail')
    },
    {
        name: 'aggregator-settlements-skipped-detail',
        props: true,
        path: 'settlements/aggregator-settlements/skipped/:settlementStatus/:id',
        meta:{
            activeTabKey:'aggregator-settlements'
        },
        component: () =>
            import ('@/pages/dashboard/settlements/aggregate/AggregateSkippedSettlementDetail')
    },
    // Settlements API route Ends

    // Merchant Report Route Start
    {
        name: 'merchant-reports',
        path: 'merchant-reports',
        meta:{
            activeTabKey:'merchant-reports'
        },
        props: true,
        component: () =>
            import ('@/pages/dashboard/merchant-report/MerchantReport')
    },
    {
        name: 'generate-merchant-report',
        path: 'merchant-report/generate',
        meta:{
            activeTabKey:'merchant-reports'
        },
        component: () =>
            import ('@/pages/dashboard/merchant-report/GenerateReport')
    },
    // Merchant Report Route End

    // Volume Reports route starts
    {
        name: 'merchant-volume-reports',
        path: 'merchant-volume-reports',
        meta:{
            activeTabKey:'merchant-volume-reports'
        },
        component: () =>
            import ('@/pages/dashboard/volume-reports/VolumeReports')
    },
    // Volume Reports route ends

    // Make Adjustment API route starts
    {
        name: 'adjustment',
        path: 'adjustment',
        meta:{
            activeTabKey:'adjustment'
        },
        component: () =>
            import ('@/pages/dashboard/adjustment/MakeAdjustment')
    },
    // Make Adjustment API route Ends


    // VpAccounts API route starts
    {
        name: 'vp-accounts',
        path: 'vp-accounts',
        meta:{
            activeTabKey:'vp-accounts'
        },
        component: () =>
            import ('@/pages/dashboard/vp-accounts/VpAccounts')
    },
    // VpAccounts API route Ends

    //case managment route starts
    {
        name: 'manage-cases',
        path: 'manage-cases',
        meta:{
            activeTabKey:'manage-cases'
        },
        component: () =>
            import ('@/pages/dashboard/case-management/CaseManagment.vue')
    },
    //case managment route ends

    //metadata route starts
    {
        name: 'card-meta-data',
        path: 'card-meta-data',
        meta:{
            activeTabKey:'card-meta-data'
        },
        component: () =>
            import ('@/pages/dashboard/meta-data/metaData.vue')
    },
    {
        name: 'add-card-meta-data',
        path: 'add-card-meta-data',
        meta:{
            activeTabKey:'card-meta-data'
        },
        component: () =>
            import ('@/pages/dashboard/meta-data/addMetaData.vue')
    },
    {
        name: 'update-card-meta-data',
        path: 'update-card-meta-data',
        meta:{
            activeTabKey:'card-meta-data'
        },
        component: () =>
            import ('@/pages/dashboard/meta-data/updateMetaData.vue')
    },
    // metadata route ends

]
